exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back {\n  margin-top: 30%;\n  background-color: #b4181d;\n  color: #fff;\n  border: 0px; }\n\n.gameDimage {\n  height: 140px;\n  box-shadow: 0px 5px 6px 1px #bdbdbd; }\n\n.shdw {\n  box-shadow: 0px 5px 6px 1px #bdbdbd; }\n\n.gameCodes {\n  min-height: 60px; }\n\n.codes {\n  border-left: 1px solid #ececec; }\n\nthead th {\n  cursor: pointer;\n  margin-right: 15px;\n  margin-left: 15px; }\n  thead th span {\n    visibility: hidden; }\n  thead th.active {\n    color: #000; }\n    thead th.active span {\n      visibility: visible; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/game-detail/game-detail.component.scss
// module id = ../../../../../src/app/game-detail/game-detail.component.scss
// module chunks = main